import React, { Fragment, useState, useEffect } from 'react';
import "./assets/css/index.css";
import fileIcon from "./assets/images/file.png";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { checkIsAgencyView, convertUTCToLocalTime, formatDate, formatFileSize, getFileBasedIcon, getOrganizationInfo, handleErrorResponse, isMobile, parseJSON, showToast } from '../../Common/Appcommon';
import { Button, Col } from "reactstrap";
import Loading from '../../Common/Loading';
import { confirmBox, getDeleteIcon, getSessionValue, translateContent, uploadFileIntoS3 } from '../../Common/Appcommon';
import { getProviderKey } from '../Agents/ProviderDetails';
import requestApiService from '../../services/requestApi.service';
import { providerUploadOptions } from './constants';
import Select from 'react-select';

const FilesMainContent = (props) => {
    let { knbData, showLoading, onFileSuccess,onEdit,handleLoader, formData, onChange,importBtnLoader,toggleImportModal} = props;
    const isSubAccountView = getSessionValue("isSubAccountView")
    const proName = getSessionValue("agent_provider_name");
    const [fileInfo, setFileInfo] = useState({});
    const [copiedId, setCopiedId] = useState(null);
    const [fileTypeImage, setFileTypeImage] = useState(null);
    const [showButtonLoading, setShowButtonLoading] = useState(false);
    const [showDeleteLoading, setShowDeleteLoading] = useState(false);
    const [knowLedgeId ,setKnowLedgeId] = useState('');
    const providerOptions = providerUploadOptions[proName];
    const [knList, setKNList] = useState([]);
    const [selectedKN, setSelectedKNOption] = useState([]);
    const [knName, setKNName] = useState("");
    const isAgencyView = checkIsAgencyView();
    useEffect( async () => {
        if(proName === "retell"){
            await processKNDataConfig(knbData);
        }
    }, [knbData]);

    useEffect(async () => {
        let knOptions = [];
        if(formData.length > 0 && proName === "retell"){
            for(let fo = 0; fo < formData.length; fo++){
                let option = [];
                let form = formData[fo];
                option = {value: form['id'], label: form['name'], row: form};
                knOptions.push(option);
            }
            setKNList(knOptions);
            let selectedKNO = {value: knbData['id'], label: knbData['name'], row: knbData};
            setSelectedKNOption(selectedKNO);
        } else {
            await processSingleFileProviders();
        }
    }, [formData,knbData]);

    const processKNDataConfig = async (knbData) => {
        if (knbData?.['details'] !== undefined && knbData?.['details'] !== null && knbData?.['details'] !== "") {
            let knbDetails = JSON.parse(knbData['details']);
            let kbId = getSessionValue("agent_provider_name") === 'vapi' ? knbDetails['id'] : knbDetails['knowledge_base_id'];
            let files = await loadKnowledgeBaseFilesList(kbId);
            setKnowLedgeId(kbId);
            if(getSessionValue("agent_provider_name") === 'retell'){
                let knbId = files?.['knowledge_base_id'];
                if(files !== undefined && files['knowledge_base_sources'] !== undefined && files['knowledge_base_sources'] !== null && files['knowledge_base_sources'] !== ''){
                    files = files['knowledge_base_sources'] !== undefined ? files['knowledge_base_sources'] : files;
                    files['knowledge_base_id']= knbId;
                }else{
                    if(files?.['status'] === 'in_progress'){
                        setFileTypeImage(fileIcon);
                    }
                }
            }
            if(files){
                setFileInfo(files);
            }
            setKNName(knbData['name']);
        }else{
            setFileInfo({});
            setKNName(getOrganizationInfo("Organization_Name") + "'s Knowledge base");
        }
    }

    const processSingleFileProviders = async () => {
        setKNName(getOrganizationInfo("Organization_Name") + "'s Knowledge base");
        let localfiles = formData;
        for(let fi = 0; fi < formData.length; fi++){
            let fdata = localfiles[fi];
            fdata['knowledge_base_id'] = fdata['knowledgeId'];
            fdata['knowledge_base_name'] = fdata['name'];
            //localfiles[fi] = fdata;
        }
        if(localfiles){
            setFileInfo(localfiles);
        }
    }

    const loadKnowledgeBaseFilesList = async (id) => {
        let params = {
            "ENTITY": "AIPROCESSOR",
            "OPERATION": "LOAD_KNB",
            "KNBID" : id,
        }
        let response = await requestApiService.processServerRequest(params, "WebV2");
        if (response.issuccess) {
            let data = response.data;
            return data;   
        }
    }
    const onCopy = (id) => {
        setCopiedId(id);
        setTimeout(() => setCopiedId(null), 1500);
    }

    const handleDownload = async (fileUrl, fileName) => {
        handleLoader(true);
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName || 'download';
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href); // Clean up URL object
        } catch (error) {
            console.error('Download failed:', error);
        }
        handleLoader(false);
    };

    const deleteFile = async (knbData, knbId) => {
        let isFileDeleted = false;
        let isDelete = await confirmBox(translateContent("vm.delete.confirm"), translateContent("vm.delete.confirm.msg"), getDeleteIcon(), 'Delete', 'Cancel');
        if (isDelete) {
            handleLoader(true);
            let proName = getSessionValue("agent_provider_name");
            let details = knbData['details'];
            details = parseJSON(details);
            let id = details['id'];
            if(proName === 'retell'){
                if(fileInfo !== undefined && Object.keys(fileInfo).length > 0){
                    id = fileInfo?.[0]['knowledge_base_id'] !== undefined && fileInfo?.[0]['knowledge_base_id'] !== null && fileInfo?.[0]['knowledge_base_id'] !== '' ? fileInfo?.[0]['knowledge_base_id'] : '';
                }
            }
            let apikey = getProviderKey(proName);
            let apiUrl = `https://api.vapi.ai/file/${id}`;
            if(proName === 'retell'){
                apiUrl = `https://api.retellai.com/delete-knowledge-base/${id}`;
            }
            try {
                /*const response = await fetch(apiUrl, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': 'Bearer ' + apikey
                    },
                });
                if (!response.ok && response.status !== 422 && response.status !== 404) {
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                } else {
                    if(proName === 'vapi'){
                        const result = await response.json();
                    }*/
                    isFileDeleted = true;
                    let formData = {
                        kId:id,
                    }
                    let params = {
                        "ENTITY": "AIPROCESSOR",
                        "OPERATION": "DELETE_KNB",
                        "ID": knbId,
                        "KNB_ID" : id,
                        "formData" : formData,
                        "isProviderUpdate" : true,
                    }
                    let formresponse = await requestApiService.processServerRequest(params, "WebV2");
                    if (formresponse.issuccess) {
                        showToast(translateContent("vm.delete.success"));
                        onFileSuccess();
                    }else{
                        handleErrorResponse(formresponse.errormsg);
                    }
                    handleLoader(false);
                // }
            } catch (error) {
                handleLoader(false);
                isFileDeleted = false;
                console.log("file delete error: ", error)
            }
        }
        return isFileDeleted;
    }

    const openEditKnwdgeModal = () => {
        onEdit();
    }

    const deleteKnbFile = async(fileDetails,knbId) => { 
        let fileId = fileDetails['id'];
        fileDetails = fileDetails["details"];
        fileDetails = parseJSON(fileDetails);
        let kId = fileDetails['knowledge_base_id'];
        let isFileDeleted = false;
        let isDelete = await confirmBox(translateContent("vm.delete.confirm"), translateContent("vm.delete.confirm.msg"), getDeleteIcon(), 'Delete', 'Cancel');
        let source_id = fileDetails?.knowledge_base_sources?.source_id ?? fileDetails?.knowledge_base_sources?.[0]?.source_id ?? "";
        if (isDelete && source_id !== "") {
            handleLoader(true);
            let proName = getSessionValue("agent_provider_name");
            let apikey = getProviderKey(proName);
            let apiUrl = `https://api.retellai.com/delete-knowledge-base-source/${kId}/source/${source_id}`;
            try {
                /*const response = await fetch(apiUrl, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': 'Bearer ' + apikey
                    },
                });
                if (!response.ok && response.status !== 422 && response.status !== 404) {
                    if(response.status === 400){
                        showToast("Cannot delete the last source.", "top-right", "error");
                    }
                    throw new Error(`Error: ${response.status} ${response.statusText}`);
                } else {
                    if(proName === 'vapi'){
                        const result = await response.json();
                    }*/
                    isFileDeleted = true;
                    let formData = {
                        kId,source_id
                    }
                    let params = {
                        "ENTITY": "AIPROCESSOR",
                        "OPERATION": "DELETE_KNB_FILE",
                        "KNB_ID" : knbId,
                        "FILE_ID" : fileId,
                        "formData" : formData,
                        "isProviderUpdate" : true,
                    }
                    let formresponse = await requestApiService.processServerRequest(params, "WebV2");
                    if (formresponse.issuccess) {
                        showToast(translateContent("vm.delete.success"));
                        onFileSuccess();
                        handleLoader(false);
                    }else{
                        handleErrorResponse(formresponse.errormsg);
                    }
                /*}*/
            } catch (error) {
                handleLoader(false);
                isFileDeleted = false;
            }
        }
        return isFileDeleted;       
    }

    
    const onAddKnowledge = (option, value) => {
        onEdit(option);
    }
    const handleKNChange = async (selectedRow, index) => {
        await processKNDataConfig(selectedRow.row);
        setSelectedKNOption(selectedRow);
        onChange(selectedRow, -1);
    }
    const getAddButtonComp = () => {
        let isSubAccountView = getSessionValue("isSubAccountView");
        if(isSubAccountView || proName === 'vapi'){
        return (
            <>
                <div className='d-flex'>
                    <div className='me-2'>
                        <Loading 
                            showLoader = {
                                importBtnLoader
                            } 
                            mainContent =
                            {isAgencyView &&
                                <Button onClick={() => toggleImportModal(false)}  className="cursor-pointer custom-btn-1 " type="submit">
                                    <span className="agent-create-btn-spn-1 justify-center">
                                        <i class="fi fi-br-plus"></i>Import 
                                    </span>
                                </Button>
                            }
                        />   
                    </div>
                    {(isAgencyView || proName === 'vapi') && <Button className='theme-bg-g' onClick={(e) => { openEditKnwdgeModal() }}><i class="fi fi-br-plus"></i> Add</Button>}
                </div>
            </>               

        )
    } else {
        return (<Fragment></Fragment>)
    }
    }
    return (
        <Fragment>
            {true && (
                <div className='file-viewer-container w-full'>
                    <div className='ps-3 pe-3 pb-2 pt-2 agent-div-container gap-2 d-flex'>
                        <div className='d-flex knwd-id-div'>
                            {(formData.length === 1 && proName === "retell") && 
                                <div className={`w-full d-flex ${proName === "vapi" ? 'align-center' : ''}`}>
                                    <div className='d-grid'>
                                    <div className="field-container-title">
                                        {knName?.trim() ? knName : <br />}
                                    </div>
                                    {proName === "retell" &&
                                    <div className={`d-flex ${getSessionValue("agent_provider_name") === 'vapi' ? 'file-viewer-id' : ''}`}>
                                        <div className="w-full d-flex desc-text gap-2 align-items-center">
                                            {/* <span className='txt-ovrflw knwd-id-txt google-ads-webhook-url' disabled={true}>Id: {knowLedgeId}</span> */}
                                            {/* <span className='cursor-poiter' onClick={(e) => onCopy(knowLedgeId)}>
                                                <i class="fi fi-rs-copy-alt"></i>
                                            </span> */}
                                            <div className='txt-ovrflw d-flex'>
                                                <div className={`google-ads-webhook-url`}>
                                                Updated At : {formatDate(convertUTCToLocalTime(knbData['updatedon']), "mmm dd, yyyy, hh:MM:ss TT")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    </div>
                                </div>
                            }
                            {formData.length > 1 && proName === "retell" && <div className='w-full d-flex'>
                                <Col md={6} className='field-section mt-1'>
                                <Select 
                                    value={selectedKN}
                                    options={knList}
                                    className="basic-select"
                                    classNamePrefix="sub-select wa-select"
                                    onChange={handleKNChange}
                                />
                            </Col>
                                
                                </div>
                            }
                            {(formData.length === 0 || proName === "vapi") && <div className='w-full d-flex align-items-center'>
                                <div className="field-container-title">
                                        {knName?.trim() ? knName : <br />}
                                    </div>
                                </div>    
                            }
                        </div>
                        <div className='mt-1 ms-auto'>
                        
                            <div className='d-flex gap-2 align-items-center ms-2'>
                            {getAddButtonComp()}
                                {getSessionValue("agent_provider_name") === 'retell' && false && 
                                    <div className='btn btn-secondary theme-bg-g align-items-center' onClick={(e) => { openEditKnwdgeModal() }}>
                                        <i class="fi fi-tc-pencil"></i> Edit
                                    </div>                                   
                                }
                                {getSessionValue("agent_provider_name") === 'retell' && 
                                <UncontrolledDropdown>
                                    <DropdownToggle className="agent-test-btn ps-2">
                                        {isAgencyView ? (
                                            <button className='dot-icon'>
                                                <i class="fi fi-rr-menu-dots-vertical mt-2 agent-option   "></i>
                                            </button>
                                        ):(
                                            <>
                                                <Button className='d-flex flex-center align-center theme-bg-g'> 
                                                    Add Knowledge 
                                                </Button>
                                            </>
                                        )}
                                    </DropdownToggle>
                                    <DropdownMenu className="agent-dropdown-lists dropdown-menu-right dropdown-menu-rounded">
                                        {
                                            providerUploadOptions[getSessionValue("agent_provider_name")] && 
                                            providerUploadOptions[getSessionValue("agent_provider_name")].map((option, index) => {
                                                let label = option.label;
                                                let value = option.value;
                                                let menuicon = option.icon;
                                                return (
                                                    <DropdownItem 
                                                        className="dropdown-list" 
                                                        onClick={e => onAddKnowledge(option, value)}
                                                    >
                                                        <i className={`fi ${menuicon}`}></i>
                                                        <span>
                                                            {label}
                                                        </span>
                                                    </DropdownItem>
                                                )
                                            })
                                        }
                                    </DropdownMenu>
                                </UncontrolledDropdown>  
} 
                                <Button className='cursor-pointer ms-auto agent-create-btn btn btn-secondary align-items-center d-flex file-icon-display hide' onClick={() => {deleteFile(knbData, knbData['id']);}}>
                                    <i class="agent-call-icon fi fi-rr-trash"></i>
                                </Button>                                   
                            </div>
                        </div>
                    </div>
                    <div>
                        {Array.isArray(fileInfo) && fileInfo.length > 0 && (
                            fileInfo.map((file, index) => {
                                let fileData = parseJSON(file['details']);
                                let syncStatus = getSessionValue("agent_provider_name") === 'retell' ? fileData?.['status'] : 'complete';
                                let sourceData = fileData?.["knowledge_base_sources"]?.[0];
                                let urlFilename = "";
                                let knowledgeName = file['knowledge_base_name'];
                                let icon = fileIcon;
                                if(getSessionValue("agent_provider_name") === 'retell'){
                                    if(sourceData?.['mimetype'] !== undefined && sourceData?.['mimetype'] !== null){
                                        icon = getFileBasedIcon(sourceData['mimetype']);
                                    }else if(sourceData?.['type'] !== undefined && sourceData?.['type'] !== null){
                                        let fName = sourceData['url'] ?? sourceData['filename'];
                                        fName = sourceData['url'] ?? sourceData['content_url'] ?? "";
                                        if(fName === undefined || fName === null){
                                            fName = sourceData?.['type'];
                                        }
                                        icon = getFileBasedIcon(fName);
                                    } else if (sourceData === null) {
                                        icon = getFileBasedIcon(file.filename);
                                    }
                                } else if(getSessionValue("agent_provider_name") === 'vapi' && fileData?.name !== undefined && fileData?.name !== null){
                                    icon = getFileBasedIcon(fileData.name);
                                }
                                return(
                                    <div key={file.id || index} className=''>
                                        <div className='file-viewer-card d-flex w-full'>
                                            <div className='file-viewer-card-body w-full'>
                                                <div className='file-viewer-stack gap-6 w-full ps-3 pe-3 pt-3'>
                                                    <div className='file-viewer-display p-2 justify-center'>
                                                        <div className='d-flex align-items-center'>
                                                            <img className='file-icon-display' src={icon} />
                                                            <div className='ms-2'>
                                                                <div className="txt-ovrflw text-base font-medium text-text">                                                                   
                                                                    {
                                                                        getSessionValue("agent_provider_name") === 'vapi' ? (
                                                                            <span>{knowledgeName} | {(fileData?.name || "")}</span>
                                                                        ) : (
                                                                            (file?.filename && file.filename.trim() !== "")
                                                                                ? file.filename
                                                                                : (fileData?.knowledge_base_sources?.title ? fileData.knowledge_base_sources.title : (urlFilename !== "" ? urlFilename : "")
                                                                            )
                                                                        )
                                                                    }
                                                                </div>
                                                                <span>  {getSessionValue("agent_provider_name") === 'vapi' ?  formatFileSize(fileData?.['bytes'] ?? fileData?.['file_size'] ?? 0 ) : sourceData !== undefined && sourceData !== null && sourceData['file_size'] !== undefined ? formatFileSize(sourceData['file_size']) : ''}</span>
                                                            </div>
                                                            <div className='ms-auto d-flex align-items-center gap-2 me-3'>
                                                                  {/* <div className='ms-auto d-flex align-items-center gap-2 me-3'> */}
                                                                    <div className={`d-flex align-items-center w-full me-1  badge ${syncStatus === 'complete' ? 'sub-sts-active' : (syncStatus === 'error' ? 'sub-sts-pym-fail' : 'sub-sts-apierror')}`}>
                                                                        <div className={`d-flex align-items-center ${syncStatus === 'error' ? 'ps-3' : ''}`}>{syncStatus === 'complete' ? 'Completed' : (syncStatus === 'error' ? 'Failed ' : 'In Progress')}</div>
                                                                    </div>
                                                                {/* </div> */}
                                                                {((getSessionValue("agent_provider_name") === 'retell' && syncStatus === "complete" && fileInfo.length > 1) || (getSessionValue("agent_provider_name") === 'vapi' && syncStatus === "complete" )) && 
                                                                <div
                                                                    className={`cursor-pointer agent-icon file-download-icon ${getSessionValue("agent_provider_name") === "retell" && (sourceData === undefined || sourceData === null || sourceData['type'] === "url") ? 'hide' : ''}`}
                                                                    onClick={() => handleDownload( getSessionValue("agent_provider_name") === 'vapi' ? fileData['url'] : sourceData['url'] ??  sourceData['content_url'] ?? sourceData['file_url'],
                                                                        getSessionValue("agent_provider_name") === 'vapi' ? fileData['name'] : (sourceData['filename'] !== undefined && sourceData['filename'] !== ''
                                                                        ? sourceData['filename'] : (sourceData['title'] !== undefined && sourceData['title'] !== null ? sourceData['title'] + ".txt" : sourceData['url'])))
                                                                    }
                                                                >
                                                                    <i className="fi fi-rr-download"></i>
                                                                </div>  
                                                                }
                                                                {((getSessionValue("agent_provider_name") === 'retell' && syncStatus === "complete" && fileInfo.length > 1) || (getSessionValue("agent_provider_name") === 'vapi' && syncStatus === "complete" && fileInfo.length >= 1)) && 
                                                                    <div 
                                                                        className='cursor-pointer agent-call-icon  file-download-icon' 
                                                                        onClick={() => {proName === "retell" ? deleteKnbFile(file, knbData['id']) : deleteFile(file, file['id'])}}
                                                                    >
                                                                        <i className="fi fi-rs-trash theme-bg-danger"></i>
                                                                    </div>
                                                                }
                                                                
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        )}     
                        {(formData.length === 0 || !Array.isArray(fileInfo) || fileInfo !== undefined && fileInfo.length === 0) && (
                            <div className='no-knowledge-container'>
                                <div className='d-flex no-knowlegde-header'>
                                    Choose a type of content below
                                </div>
                                <div className={`${isMobile() ? "list-btn-view" : "d-flex"} col-md-12 clickable-container`}>
                                    {
                                        providerOptions.map((option, index) => {
                                            let value = option.value;
                                            let label = option.label;
                                            let icon = option.icon;
                                            let desc = option.desc;
                                            return (
                                                <div 
                                                    onClick={(e) => {onAddKnowledge(option, value)}} 
                                                    className={`${isMobile() ? "col-md-10 mb-4" : (getSessionValue("agent_provider_name") === 'retell' ? "col-md-3" : "col-md-10")} clickable-element shadow cursor-pointer`}
                                                >
                                                    <div className='clickable-header d-grid'>
                                                        <div className='d-flex'>
                                                            <div className='icon-container'>
                                                                <i className={`fi ${icon}`}></i>
                                                            </div>
                                                            <div className='icon-add'>
                                                                <i class="fi fi-br-plus"></i>
                                                            </div>
                                                        </div>
                                                        <div className='clickable-header-title'>
                                                        {label}
                                                        </div>
                                                    </div>
                                                    <div className='clickable-header-content'>
                                                        {desc}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>    
                        )}
                    </div>
                </div>
            )}
        </Fragment >
    )
}

export default FilesMainContent;